export enum ValidationResponseEnum {
    MISSING_VALUE = 'missing',
    INVALID_VALUE = 'invalid',
    VALID_VALUE = 'valid'
}